import React, { useContext, useEffect, useState } from 'react'
import API from '../../../../../services/API'
import Alert from '@mui/material/Alert'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import Comments from '../../../../../components/Comments/Comments'

const NotesTab = ({ employeeID }) => {
  const [notes, setNotes] = useState([])
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)

  const loadNotes = () => {
    !loading && setLoading(true)
    if (!employeeID) return
    API.get(`/employee/${employeeID}/notes`)
      .then((res) => {
        if (res.status === 200) {
          setNotes(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch((e) => {
        console.error(e)
        setFetchError(true)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    loadNotes()
  }, [employeeID])

  return (
    <Stack gap={1} marginTop={1}>
      {loading ? (
        <LinearProgress />
      ) : fetchError ? (
        <Alert severity="error">
          Unable to load Notes. Please try again later.
        </Alert>
      ) : (
        <Comments
          comments={notes}
          onSubmit={(note) => {
            return new Promise((resolve, reject) => {
              API.post(`/employee/${employeeID}/notes`, {
                note,
              }).then((res) => {
                if (res.status === 200) {
                  loadNotes()
                  resolve()
                } else {
                  setToast({
                    severity: 'error',
                    message: 'Unable to submit note. Please try again later.',
                  })
                  reject()
                }
              })
            })
          }}
        />
      )}
    </Stack>
  )
}

export default NotesTab
